import { memo } from '@morphic-ts/common/es6/utils';
import { pipe } from 'fp-ts/es6/function';
import { eqApplyConfig } from '../config';
import { EqType, EqURI } from '../hkt';
const coerce = (e) => e;
/**
 *  @since 0.0.1
 */
export const eqNewtypeInterpreter = memo(() => ({
    _F: EqURI,
    newtype: () => (getEq, config) => env => pipe(coerce(getEq(env).eq), eq => new EqType(eqApplyConfig(config)(eq, env, { eq }))),
    newtypeIso: (iso, getEq, name, config) => env => pipe(getEq(env).eq, eq => new EqType(eqApplyConfig(config)({
        equals: (y, x) => eq.equals(iso.reverseGet(y), iso.reverseGet(x))
    }, env, { eq }))),
    newtypePrism: (prism, getEq, name, config) => env => pipe(getEq(env).eq, eq => new EqType(eqApplyConfig(config)({
        equals: (y, x) => eq.equals(prism.reverseGet(y), prism.reverseGet(x))
    }, env, { eq })))
}));
